import { billingRequest } from "./billing-client";

export interface CustomerDto {
  id: string;
  code: string;
  displayName: string;
  email: string | null;
  phone: string | null;
  website: string | null;
  notes: string | null;
  country: string | null;
  taxId: string | null;
  currency: string;
  balance: string;
  totalInvoiced: string;
  status: string;
  createdAt: string;
  iamUserId?: string | null;
}

export interface CustomerDetailDto extends CustomerDto {
  addresses: Array<{
    id: string;
    type: string;
    name: string | null;
    addressLine1: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    pincode: string | null;
  }>;
  bankAccounts: Array<{
    id: string;
    bankName: string;
    branch: string | null;
    accountHolder: string;
    accountNumber: string;
    ifsc: string | null;
  }>;
  ledgerEntries: Array<{
    id: string;
    reference: string | null;
    entryDate: string;
    mode: string;
    amount: string;
    closingBalance: string;
  }>;
  invoices: Array<{
    id: string;
    number: string;
    status: string;
    total: string;
    paidAmount: string;
    dueDate: string | null;
    createdAt: string;
  }>;
}

export interface CustomerListResponse {
  items: CustomerDto[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

export interface CustomerAddressPayload {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  country?: string;
  pincode?: string;
}

export interface CustomerBankPayload {
  bankName?: string;
  branch?: string;
  accountHolder?: string;
  accountNumber?: string;
  ifsc?: string;
}

export interface CreateCustomerPayload {
  code: string;
  displayName: string;
  email?: string;
  phone?: string;
  website?: string;
  notes?: string;
  country?: string;
  taxId?: string;
  currency?: string;
  billingAddress?: CustomerAddressPayload;
  bankAccount?: CustomerBankPayload;
}

export interface UpdateCustomerPayload {
  displayName?: string;
  email?: string;
  phone?: string;
  website?: string;
  notes?: string;
  country?: string;
  taxId?: string;
  currency?: string;
  billingAddress?: CustomerAddressPayload;
  bankAccount?: CustomerBankPayload;
}

export const customersApi = {
  list: (params?: { page?: number; limit?: number }) => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    const query = q.toString();
    return billingRequest<CustomerListResponse>(`/customers${query ? `?${query}` : ""}`);
  },
  get: (id: string) => billingRequest<CustomerDetailDto>(`/customers/${id}`),
  create: (payload: CreateCustomerPayload) =>
    billingRequest<CustomerDto>("/customers", { method: "POST", body: JSON.stringify(payload) }),
  update: (id: string, payload: UpdateCustomerPayload) =>
    billingRequest<CustomerDto>(`/customers/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  linkPortalAccess: (id: string, payload: { iamUserId: string; email?: string }) =>
    billingRequest<{ customerId: string; iamUserId: string; email: string | null }>(
      `/customers/${id}/portal-access`,
      { method: "POST", body: JSON.stringify(payload) },
    ),
};
